<template>
	<div class="notification-sources">
		<div class="sources-list">
			<template v-if="sources && sources.length > 0">
				<div class="source-box all-sources" @click="onClickAllSources">
					All
				</div>
				<SourceBox
					v-for="(source, index) of sources"
					:key="componentKey + index"
					:source="source"
					:selected="source.selected"
					@click="onSourceClick(index)"
				></SourceBox>
				<div class="more-source-container" v-if="sources.length > 0">
					<div class="more-source-toggle" :class="{ active: openSearch }" @click="onClickToggleMoreSources">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="6.904"
							height="11.047"
							viewBox="0 0 6.904 11.047"
						>
							<g transform="translate(0.547 0.547)">
								<path
									data-name="ew-icon_arrow_right"
									d="M14.827,8.543l3.96,3.957-3.96,3.957a.266.266,0,0,0,0,.374l.591.591a.266.266,0,0,0,.374,0l4.146-4.146.591-.591a.266.266,0,0,0,0-.374l-.591-.591L15.793,7.577a.266.266,0,0,0-.374,0l-.591.591A.266.266,0,0,0,14.827,8.543Z"
									transform="translate(-14.75 -7.5)"
									fill="none"
									stroke="#fff"
									stroke-miterlimit="10"
									stroke-width="1"
								/>
							</g>
						</svg>
					</div>
					<div class="more-source-dropdown" :class="{ active: openSearch }">
						<div
							v-for="(source, index) of sources"
							:key="componentKey + index"
							class="more-source-item"
							@click="onSourceClick(index)"
						>
							<SourceBox :source="source" :selected="source.selected"></SourceBox>
							<span class="source-name">{{ source.name }}</span>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import SourceBox from './SourceBox';

const colors = ['--experience-color', '--campaign-color', '--event-color', '--story-color', '--offer-color'];

export default {
	components: {
		SourceBox,
	},
	data() {
		return {
			sources: [],
			openSearch: false,
			componentKey: 0,
		};
	},
	async mounted() {
		await this.load();
	},
	methods: {
		async load() {
			this.sources = await this.$repo.activity.getNotificationSources();
			if (this.sources && this.sources.length > 0) {
				for (let s of this.sources) {
					if (!s.picture) {
						s.color = this.getRandomColor();
					}
					if (s.name) {
						s.firstLetter = this.getFirstLetter(s.name);
					}
				}
			}
		},
		getFirstLetter(text) {
			if (text && text.length > 0) {
				return text[0].toUpperCase();
			} else {
				return '?';
			}
		},
		onClickToggleMoreSources() {
			this.openSearch = !this.openSearch;
		},
		onSourceClick(index) {
			this.sources[index].selected = !this.sources[index].selected;
			this.triggerChange();
		},
		onClickAllSources() {
			for (let s of this.sources) {
				s.selected = false;
			}
			this.openSearch = false;
			this.triggerChange();
		},
		getRandomColor() {
			const length = colors.length - 1;
			const index = length % Number.parseInt(Math.random() * 10);
			return colors[index];
		},
		forceRerender() {
			this.componentKey += 1;
		},
		triggerChange() {
			const selectedSources = this.sources.filter((it) => it.selected).map((it) => it.rawId);
			this.$emit('change', selectedSources);
			this.forceRerender();
		},
	},
};
</script>

<style lang="scss">
.notification-sources {
	display: flex;
	user-select: none;

	.sources-list {
		display: flex;
		position: relative;
		width: 100%;
	}

	.source-box {
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--primary-color);
		color: #fff;
		cursor: pointer;
		opacity: 0.3;
		transition: 0.3s ease all;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&.selected,
		&:hover,
		&:focus {
			opacity: 1;
		}

		& + .source-box {
			margin-left: 5px;
		}

		&.all-sources {
			text-transform: uppercase;
			background-color: var(--campaign-color);
			font-family: 'Roboto', 'Sans-serif';
			font-size: 12px;
			font-weight: bold;
			opacity: 1;
		}
	}

	.more-source-toggle {
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #b9b9b9;
		cursor: pointer;
		transition: 0.3s ease all;
		margin-left: 5px;

		svg {
			transition: 0.3s ease all;
		}

		&.active {
			background-color: #58595b;

			svg {
				transform: rotate(90deg);
			}
		}
	}

	.more-source-dropdown {
		position: absolute;
		left: 0;
		width: 100%;
		z-index: 2;
		background-color: #fff;
		margin-top: 10px;
		box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
		padding: 5px;
		opacity: 0;
		pointer-events: none;
		transition: 0.3s ease all;

		&.active {
			opacity: 1;
			pointer-events: initial;
		}

		.more-source-item {
			display: flex;
			align-items: center;
			cursor: pointer;

			.source-name {
				flex: 1 1 auto;
				margin-left: 5px;
				font-size: 12px;
			}

			&:hover .source-box {
				opacity: 1;
			}

			& + .more-source-item {
				margin-top: 5px;
			}
		}
	}
}
</style>
